<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <label> Compras/ Pedido </label>
    </div>
    <v-container fluid
      ><v-row align="center">
        <v-col cols="12" sm="2"> </v-col>
        <v-col cols="12" sm="8">
          <v-radio-group v-model="selectedFilter" row>
            <v-radio value="0">
              <template v-slot:label>
                <v-avatar size="25" color="primary">
                  <span class="white--text text-h6">TD</span>
                </v-avatar>
                <div class="ma-1 text-h5">Todas</div>
              </template></v-radio
            >
            <v-radio value="AA">
              <template v-slot:label>
                <v-avatar size="25" color="red">
                  <span class="white--text text-h6">AA</span>
                </v-avatar>
                <div class="ma-1 text-h5">Aguardando Aprovação</div>
              </template>
            </v-radio>
            <v-radio value="EP">
              <template v-slot:label>
                <v-avatar size="25" color="red">
                  <span class="white--text text-h6">EP</span>
                </v-avatar>
                <div class="ma-1 text-h5">Envio Pendente</div>
              </template>
            </v-radio>
            <v-radio value="PE">
              <template v-slot:label>
                <v-avatar color="green" size="25">
                  <span class="white--text text-h6">PE</span>
                </v-avatar>
                <div class="ma-1 text-h5">Pedido Enviado</div>
              </template>
            </v-radio>
            <!--<v-radio value="AR">
              <template v-slot:label>
                <v-avatar color="yellow" size="25">
                  <span class="white--text text-h6">AR</span>
                </v-avatar>
                <div class="ma-1 text-h5">Aguardando Recebimento</div>
              </template>
            </v-radio>-->
            <v-radio value="RP">
              <template v-slot:label>
                <v-avatar color="yellow" size="25">
                  <span class="white--text text-h6">RP</span>
                </v-avatar>
                <div class="ma-1 text-h5">Recebimento Parcial</div>
              </template>
            </v-radio>
            <v-radio value="IR">
              <template v-slot:label>
                <v-avatar color="green" size="25">
                  <span class="white--text text-h6">IR</span>
                </v-avatar>
                <div class="ma-1 text-h5">Itens Recebidos</div>
              </template>
            </v-radio>
            <v-radio value="B">
              <template v-slot:label>
                <v-avatar color="grey darken-1" size="25">
                  <span class="white--text text-h6">I</span>
                </v-avatar>
                <div class="ma-1 text-h5">Inativo</div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="1">
          <!--<v-btn
            @click="baixarlista()"
            v-if="pedidos.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>-->
        </v-col>
      </v-row>
      <v-row align="right">
        <v-col cols="12" sm="6" md="3" class="text-left">
          <v-menu
            v-model="menuData1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="computedDataIni"
                label="Data inicio"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate1"
                @click:clear="dataIni = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataIni"
              @input="menuData1 = false"
              @change="dateChangeDataIni"
              :max="new Date().toISOString().substr(0, 10)"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="text-left">
          <v-menu
            v-model="menuData2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedDataFim"
                label="Data fim"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate2"
                @click:clear="dataFim = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataFim"
              @input="menuData2 = false"
              @change="dateChangeDataFim"
              locale="pt-br"
              forma
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        class="elevation-1"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :custom-filter="filter"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.status="{ item }">
          <v-avatar v-if="item.status == 'AA'" color="red" size="24">
            <span class="white--text text-h5">AA</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'EP'" color="red" size="24">
            <span class="white--text text-h5">EP</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'PE'" color="green" size="24">
            <span class="white--text text-h5">PE</span>
          </v-avatar>
          <!--<v-avatar v-else-if="item.status == 'AR'" color="yellow" size="24">
            <span class="white--text text-h5">AR</span>
          </v-avatar>-->
          <v-avatar v-else-if="item.status == 'RP'" color="yellow" size="24">
            <span class="white--text text-h5">RP</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'IR'" color="green" size="24">
            <span class="white--text text-h5">IR</span>
          </v-avatar>
          <v-avatar v-else color="blue-grey lighten-4" size="24">
            <span class="white--text text-h5">I</span>
          </v-avatar>
        </template>
        <template v-slot:item.id="{ item }">
          {{ item.nome == null ? item.id : item.nome }}
        </template>
        <template v-slot:item.observacao="{ item }">
          <v-text-field v-model="item.observacao" :readonly="apenasLeitura">
          </v-text-field>
        </template>
        <template v-slot:item.dataCriacao="{ item }">
          <span>{{
            new Date(item.dataCriacao)
              .toLocaleString()
              .replace(/(.*)\D\d+/, "$1")
          }}</span>
        </template>

        <template v-slot:item.idMapaCotacao="{ item }">
          <span v-if="item.idMapaCotacao && item.idMapaCotacao !== 0">
            <a
              href="#"
              @click.prevent="abrirPdfMapa(item)"
              class="text--primary font-weight-medium text-decoration-underline"
            >
              {{ item.idMapaCotacao }}
            </a>
          </span>
          <span v-else>—</span>
        </template>

        <template v-slot:item.idRequisicao="{ item }">
          <span v-if="item.idRequisicao && item.idRequisicao !== 0">
            <a
              href="#"
              @click.prevent="abrirPdfRequisicao(item)"
              class="text--primary font-weight-medium text-decoration-underline"
            >
              {{ item.idRequisicao }}
            </a>
          </span>
          <span v-else>—</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                class="mr-2"
                @click="aprovarPedido(item)"
                v-bind="attrs"
                v-on="on"
                v-if="statusPermite(item) && isApproving(idModulo)"
              >
                mdi-close-circle
              </v-icon>
              <v-icon
                color="primary"
                class="mr-2"
                @click="show(item)"
                v-bind="attrs"
                v-on="on"
                v-else
              >
                mdi-file-search
              </v-icon>
            </template>
            <span v-if="statusPermite(item) && isApproving(idModulo)">Aprovar requisição</span>
            <span v-else>Visualizar em PDF</span>
          </v-tooltip>
          <v-tooltip v-if="isAllowed(11)" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="enviar(item)"
                v-bind="attrs"
                v-on="on"
                :disabled="item.status != 'EP'"
              >
                mdi-send
              </v-icon>
            </template>
            <span>Enviar Pedido</span>
          </v-tooltip>
          <v-tooltip v-if="isInactive(idModulo)" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="error"
                class="mr-2"
                @click="inativar(item)"
                v-bind="attrs"
                v-on="on"
                :disabled="!pedidoPodeSerInativado(item)"
              >
                mdi-close-thick
              </v-icon>
            </template>
            <span>Inativar</span>
          </v-tooltip>
        </template>
        <template v-slot:item.data="{ item }">
          <span>{{
            new Date(item.data).toLocaleString().replace(/(.*)\D\d+/, "$1")
          }}</span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  canApproveModule,
  canInactivateModule,
  getUserPermission,
  getUserRoles,
  logApprovalDiagnostics,
  explainApprovalButtonState,
} from "@/services/loginService";
import { getPdf as getPedidoPdf } from "../../../services/pedidoService";
import { getPdf as getMapaPdf } from "../../../services/mapaCotacaoService";
import { getPdf as getRequisicaoPdf } from "../../../services/requisicaoServicoService";
import { abrirJanelaPdf } from "@/services/pdfHelper";
import moment from "moment";

export default {
  name: "listaPedido",
  data() {
    return {
      idModulo: 11,
      selectedFilter: "0",
      loading: false,
      search: "",
      showAtivo: false,
      apenasLeitura: false,
      active_tab: 2,
      dataIni: null,
      dataFim: null,
      menuData1: false,
      menuData2: false,
      arrayEvents: null,
      headers: [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        { text: "MC", value: "idMapaCotacao" },
        { text: "Data/Hora", value: "dataCriacao" },
        { text: "Fornecedor", value: "fornecedor" },
        { text: "Empresa", value: "empresa" },
        { text: "Requisicão Serviço", value: "idRequisicao" },
        { text: "Responsável", value: "comprador" },
        { text: "Status", value: "status" },
        { text: "Ações", value: "actions", sortable: false, width: "18%" },
      ],

      filters: {
        id: [],
        idMapaCotacao: [],
        dataCriacao: [],
        fornecedor: [],
        empresa: [],
        comprador: [],
        centroCusto: [],
      },
    };
  },
  computed: {
    ...mapState("pedido", ["pedidos"]),
    filteredList() {
      const searchLower = this.search.toLowerCase();

      return this.pedidos
        .filter((p) => {
          // 1. Filtro por texto digitado
          const buscaTexto =
            p.id.toString().toLowerCase().includes(searchLower) ||
            (p.empresa || "").toLowerCase().includes(searchLower) ||
            (p.fornecedor || "").toLowerCase().includes(searchLower) ||
            (p.comprador || "").toLowerCase().includes(searchLower) ||
            p.produtos.some(
              (i) =>
                i.localEntrega?.toLowerCase().includes(searchLower) ||
                i.unidadeMedida?.toLowerCase().includes(searchLower) ||
                i.produto?.toLowerCase().includes(searchLower) ||
                i.centroCusto?.toLowerCase().includes(searchLower)
            );

          // 2. Filtro por data (se datas forem preenchidas)
          const dataValida =
            !this.dataIni ||
            !this.dataFim ||
            (new Date(p.dataCriacao.split("T")[0]) >=
              new Date(this.dataIni.split("T")[0]) &&
              new Date(p.dataCriacao.split("T")[0]) <=
                new Date(this.dataFim.split("T")[0]));

          // 3. Filtros refinados (filters)
          const filtrosOk = Object.keys(this.filters).every((f) => {
            if (this.filters[f].length < 1) return true;

            if (f === "data") {
              const dataFormatada = new Date(p[f])
                .toLocaleString()
                .replace(/(.*)\D\d+/, "$1");
              return this.filters[f].includes(dataFormatada);
            }

            if (f === "centroCusto") {
              return p.produtos.some((p) =>
                this.filters[f].includes(p.centroCusto)
              );
            }

            return this.filters[f].includes(p[f]);
          });

          // 4. Filtro por status (se não for "0")
          const statusOk =
            this.selectedFilter === "0" || p.status === this.selectedFilter;

          return buscaTexto && dataValida && filtrosOk && statusOk;
        })
        .sort((a, b) => b.id - a.id);
    },

    computedDataIni() {
      return this.dataIni ? moment(this.dataIni).format("DD/MM/YYYY") : null;
    },
    computedDataFim() {
      return this.dataFim ? moment(this.dataFim).format("DD/MM/YYYY") : null;
    },
  },
  methods: {
    ...mapActions("pedido", ["atualizarPedidos", "atualizarPedido"]),

    columnValueList(val) {
      if (val == "data") {
        return this.pedidos.map((d) =>
          new Date(d[val]).toLocaleString().replace(/(.*)\D\d+/, "$1")
        );
      } else {
        return this.pedidos.map((d) => d[val]);
      }
    },
    abrirPdfMapa(item) {
      getMapaPdf(item.idMapaCotacao, abrirJanelaPdf());
    },
    abrirPdfRequisicao(item) {
      getRequisicaoPdf(item.idRequisicao, abrirJanelaPdf());
    },
    show(item) {
      getPedidoPdf(item.id, abrirJanelaPdf());
    },
    aprovarPedido(item) {
      this.atualizarPedido(item);
      this.$router.push(`/pedido/aprovar`);
    },
    inativar(item) {
      if (!this.pedidoPodeSerInativado(item)) {
        return;
      }
      this.atualizarPedido(item);
      this.$router.push(`/pedido/inativar`);
    },
    enviar(pedido) {
      this.atualizarPedido(pedido);
      this.$router.push(`/pedido/enviar`);
    },
    async obterLista() {      
      if (this.$store.getters["pedido/ultimaAtualizacaoListaPedido"]) {
        this.loading = true;
      await this.atualizarPedidos();
        this.loading = false;
      }
    },
    isAllowed(id) {
      return getUserPermission(id);
    },

    isApproving(id) {
      return canApproveModule(id);
    },
    isInactive(id) {
      return canInactivateModule(id);
    },
    statusPermite(pedido) {
      const permite = pedido.status === "AA";
      logApprovalDiagnostics("Pedido/Lista:Aprovar", explainApprovalButtonState({
        modulo: this.idModulo,
        registro: pedido,
        action: "aprovar",
        statusPermitidos: ["AA"],
      }));
      return permite;
    },
    pedidoPodeSerInativado(pedido) {
      return !["RP", "IR", "I"].includes(pedido.status);
    },
    onInputDate1(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid() && newDate <= new Date()) {
          this.dataIni = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataIni(date) {
      this.dataIni = date;
    },
    onInputDate2(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid()) {
          this.dataFim = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataFim(date) {
      this.dataFim = date;
    },
  },
  created: function () {
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
};
</script>
